import { useMemo } from "react";

import { ISignedUrl } from "../../../../../../../../common/models/signedUrl";
import { usePTGetZonesByDevice } from "./usePTGetZonesByDevice";

export interface IZonesByDeviceTableRow extends ISignedUrl {
  id: string;
  deviceId: string;
  name: string;
  pan: string;
  tilt: string;
  zoom: string;
  status: boolean;
  keyFrame: string;
  focusMode: string | null;
  focusDistance: string | null;
  focusRect: string | null;
}

export interface IGetZonesByDeviceTableRow {
  rows: IZonesByDeviceTableRow[];
  loading: boolean;
}

export const usePTGetZonesByDeviceTableRow = (
  currentDeviceId: string
): IGetZonesByDeviceTableRow => {
  const { data, loading } = usePTGetZonesByDevice(currentDeviceId);

  const rows = useMemo((): IZonesByDeviceTableRow[] => {
    return (
      data?.getZonesByDevice.items?.map(item => ({
        id: item?.id ?? "",
        deviceId: item?.deviceId ?? "",
        name: item?.name ?? "",
        pan: item?.pan ?? "",
        tilt: item?.tilt ?? "",
        zoom: item?.zoom ?? "",
        status: item?.status ?? false,
        keyFrame: item?.keyFrame ?? "",
        signedUrlKeyFrame: item?.signedUrlKeyFrame ?? "",
        focusMode: item?.focusMode ?? null,
        focusDistance: item?.focusDistance ?? null,
        focusRect: item?.focusRect ?? null,
      })) ?? []
    );
  }, [data?.getZonesByDevice.items]);

  return { rows, loading };
};
